import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'contact',
  `
    RESET_ATTEMPT_ID
  `
);
